import { useSyncExternalStore } from "react"
import { getShellNavPendingHref, subscribeShellNavPending } from "@/lib/shell-nav-pending"

/** Server URL until a sidebar click, then the clicked href. Subscribing does not rerender the page. */
export function useShellNavUrl(serverUrl: string): string {
  const pending = useSyncExternalStore(subscribeShellNavPending, getShellNavPendingHref, getShellNavPendingHref)
  return pending ?? serverUrl
}
